var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductCopilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125.66 45.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #138d7e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.76,2.5c-2.89,0-5.47,1.79-6.49,4.49-1.55-.7-3.33-.7-4.88,0-1.19-3.13-4.44-4.97-7.74-4.37-3.3.6-5.69,3.47-5.7,6.82v15.88c0,3.84,3.11,6.95,6.95,6.95s6.95-3.11,6.95-6.95v-.99c0-1.1.89-1.98,1.98-1.98s1.98.89,1.98,1.98v.99c0,3.84,3.11,6.95,6.95,6.95s6.95-3.11,6.95-6.95v-15.88c0-1.84-.73-3.61-2.03-4.91s-3.07-2.03-4.91-2.03h0ZM53.9,28.29c-1.2,0-2.29-.72-2.75-1.84-.46-1.11-.21-2.39.65-3.24.85-.85,2.13-1.11,3.24-.65,1.11.46,1.84,1.55,1.84,2.75,0,1.64-1.33,2.98-2.98,2.98ZM56.88,12.42v6.63c-1.88-.91-4.07-.91-5.95,0v-9.61c0-1.64,1.33-2.98,2.98-2.98s2.98,1.33,2.98,2.98v2.98ZM64.81,14.4v4.32c-1.28-.46-2.69-.46-3.97,0v-6.3c0-1.1.89-1.98,1.98-1.98s1.98.89,1.98,1.98v1.98ZM71.76,28.29c-1.2,0-2.29-.72-2.75-1.84-.46-1.11-.21-2.39.65-3.24.85-.85,2.13-1.11,3.24-.65,1.11.46,1.84,1.55,1.84,2.75,0,1.64-1.33,2.98-2.98,2.98ZM74.74,19.05c-1.88-.91-4.07-.91-5.95,0v-9.61c0-1.64,1.33-2.98,2.98-2.98s2.98,1.33,2.98,2.98v9.61Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 39.1,
    width: 125.66,
    height: 6.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCopilot);
export default __webpack_public_path__ + "static/media/product-copilot.f7ef6f1a37663369db3539898e33ddeb.svg";
export { ForwardRef as ReactComponent };